/**
 * Core
 */
import { createRouter, createWebHistory } from 'vue-router';

/**
 * Views
 */
import Admin from './views/Admin.vue';
import Account from './views/Account.vue';
import Errors from './views/Errors.vue';
import Ingredients from './views/Ingredients.vue';
import Login from './views/Login.vue';
import Logout from './views/Logout.vue';
import Packages from './views/Packages.vue';
import PasswordChange from './views/PasswordChange.vue';
import PasswordReset from './views/PasswordReset.vue';
import Products from './views/Products.vue';
import ProductTypes from './views/ProductTypes.vue';
import Splashscreen from './views/SplashScreen.vue';
import Units from './views/Units.vue';
import Users from './views/Users.vue';
import Statuses from './views/Statuses.vue';

/**
 * Subviews
 */
import IngredientForm from './components/forms/IngredientForm.vue';
import NoPermissions from './views/NoPermissions.vue';
import PackageForm from './components/forms/PackageForm.vue';
import ProductForm from './components/forms/ProductForm/template.vue';
import ProductTypeForm from './components/forms/ProductTypeForm.vue';
import StatusForm from './components/forms/StatusForm.vue';
import UnitForm from './components/forms/UnitForm.vue';
import UserForm from './components/forms/UserForm.vue';

/**
 * Helpers
 */
import SanitizeUtils from './utils/SanitizeUtils';
import store from './store';

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  linkActiveClass: 'active',
  linkExactActiveClass: 'exact-active',
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
  routes: [
    // eslint-disable-next-line
    { path: '/login', component: Login, name: 'Logowanie', meta: { layout: 'guest' } },
    // eslint-disable-next-line
    { path: '/password/reset', component: PasswordReset, name: 'Reset hasła', meta: { layout: 'guest' } },
    // eslint-disable-next-line
    { path: '/password/reset/:token/:email', component: PasswordChange, name: 'Zmiana hasła', meta: { layout: 'guest' } },
    { path: '/logout', component: Logout, name: 'Wyloguj', },
    { path: '/loading', component: Splashscreen, name: 'Splashscreen' },
    { path: '/', redirect: '/products' },
    { path: '/account', component: Account, name: 'Twoje konto' },
    { path: '/packages', component: Packages, name: 'Opakowania' },
    { path: '/packages/new', component: PackageForm, name: 'Dodawanie opakowania' },
    { path: '/packages/:id', component: PackageForm, name: 'Edycja opakowania' },
    { path: '/products', component: Products, name: 'Produkty' },
    { path: '/archive', component: Products, name: 'Archiwum', props: { archived: true } },
    { path: '/products/new', component: ProductForm, name: 'Dodawanie produktu' },
    { path: '/products/:id', component: ProductForm, name: 'Edycja produktu' },
    { path: '/ingredients', component: Ingredients, name: 'Składniki' },
    { path: '/ingredients/new', component: IngredientForm, name: 'Dodawanie składnika' },
    { path: '/ingredients/:id', component: IngredientForm, name: 'Edycja składnika' },
    { path: '/admin', component: Admin, name: 'Panel administratora' },
    { path: '/admin/users', component: Users, name: 'Użytkownicy' },
    { path: '/admin/users/new', component: UserForm, name: 'Dodawanie Użytkownika' },
    { path: '/admin/users/:id', component: UserForm, name: 'Edycja użytkownika' },
    { path: '/admin/product-types', component: ProductTypes, name: 'Kategorie produktów' },
    { path: '/admin/product-types/new', component: ProductTypeForm, name: 'Dodawanie kategorii produktu' },
    { path: '/admin/product-types/:id', component: ProductTypeForm, name: 'Edycja kategorii produktu' },
    { path: '/admin/units', component: Units, name: 'Jednostki/typy bułek' },
    { path: '/admin/units/new', component: UnitForm, name: 'Dodawanie jednostki/typu bułki' },
    { path: '/admin/units/:id', component: UnitForm, name: 'Edycja jednostki/typu bułki' },
    { path: '/admin/statuses', component: Statuses, name: 'Statusy produktów' },
    { path: '/admin/statuses/new', component: StatusForm, name: 'Dodawanie statusu' },
    { path: '/admin/statuses/:id', component: StatusForm, name: 'Edycja statusu' },
  ]
});

router.beforeEach((to, from, next) => {
  let notLoggedInRoutes = [
    'Logowanie',
    'Wyloguj',
    'Reset hasła',
    'Zmiana hasła'
  ];

  if (notLoggedInRoutes.indexOf(to.name) === -1 && !store.getters['user/isLoggedIn']) {
    let splashscreenHtml = document.querySelector('#splashscreen');

    if (splashscreenHtml) {
      splashscreenHtml.parentNode.removeChild(splashscreenHtml);
    }

    next({ name: 'Logowanie' });
    return;
  }

  if (notLoggedInRoutes.indexOf(to.name) !== -1) {
    let splashscreenHtml = document.querySelector('#splashscreen');

    if (splashscreenHtml) {
      splashscreenHtml.parentNode.removeChild(splashscreenHtml);
    }

    next();
    return;
  }

  if (!window.crmApp) {
    setTimeout(() => {
      next({
        name: 'Splashscreen',
        params: {
          nextRoute: to.path
        }
      });

      let splashscreenHtml = document.querySelector('#splashscreen');

      if (splashscreenHtml) {
        splashscreenHtml.parentNode.removeChild(splashscreenHtml);
      }
    }, 0);

    return;
  }

  next();
});

export default router;
